import { render, staticRenderFns } from "./invitationDetails.vue?vue&type=template&id=47949304&scoped=true&"
import script from "./invitationDetails.vue?vue&type=script&lang=js&"
export * from "./invitationDetails.vue?vue&type=script&lang=js&"
import style0 from "./invitationDetails.vue?vue&type=style&index=0&id=47949304&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47949304",
  null
  
)

export default component.exports